export default "__VITE_ASSET__04eb4c89__"